import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { LucideCircleCheck, LucideInfo, LucideTriangleAlert, LucideCircleX } from '@lucide/angular';
import { Auth } from '@/app/core/services/auth';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConfirmDialogModule, ToastModule, LucideCircleCheck, LucideInfo, LucideTriangleAlert, LucideCircleX],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private readonly auth = inject(Auth);

  protected readonly isLogin = computed(() => this.auth.authToken());
}
